import { render } from "./StoryQuote.vue?vue&type=template&id=eb517a3a&scoped=true"
import script from "./StoryQuote.vue?vue&type=script&lang=js"
export * from "./StoryQuote.vue?vue&type=script&lang=js"

import "./StoryQuote.vue?vue&type=style&index=0&id=eb517a3a&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb517a3a"]])

export default __exports__